const hasValueClass = 'has-value';

/* Logic for select lists */
const selectList = (form) => {
  // Array of select lists in a form
  const selectFields = Array.from(
    form.querySelectorAll('.wpforms-field-select')
  );

  /**
   * Looping every select field, to set a 'has value' class on the
   * wrapper for floating label styling, based on the select value.
   */
  selectFields.forEach(handleHasValueClass);
};

/**
 * Sets the 'has value' class on a select field wrapper. Call it after
 * changing the select's options or value from code, as that doesn't fire a
 * change event.
 */
export const setHasValueClass = (selectField) => {
  const selectEl = selectField.querySelector('select');

  selectField.classList.toggle(hasValueClass, Boolean(selectEl?.value));
};

export const handleHasValueClass = (selectField) => {
  const selectEl = selectField.querySelector('select');

  if (!selectEl) {
    return;
  }

  selectEl.addEventListener('change', () => setHasValueClass(selectField));

  // Check for initial values, and set class on select field
  setHasValueClass(selectField);
};

export default selectList;
